const ErrorMessage = ({ error }) => {
    return error ? (
        <label className="text-danger" style={{ fontSize: 12 }}>{error}</label>
    ) : null;
  };
  
  export default ErrorMessage;
  